module.exports = __webpack_public_path__ + "248e39c3d614fdde509d3c26f05de64b.MP3";